export var RulebookStyle = /*#__PURE__*/ function(RulebookStyle) {
    RulebookStyle["Popup"] = "popup";
    RulebookStyle["Fullscreen"] = "fullscreen";
    RulebookStyle["Discord"] = "discord";
    RulebookStyle["Mobile"] = "mobile";
    return RulebookStyle;
}({});
export var RulebookPage = /*#__PURE__*/ function(RulebookPage) {
    RulebookPage["Classic4P"] = "bg";
    RulebookPage["Classic56P"] = "56p";
    RulebookPage["Seafarers4P"] = "sf";
    RulebookPage["CitiesAndKnights4P"] = "ck";
    RulebookPage["ColonistRush4P"] = "colonistrush";
    return RulebookPage;
}({});
export function getRulebookPagePathname(page) {
    switch(page){
        case "bg":
            return '';
        case "56p":
            return '/5-6-player';
        case "sf":
            return '/seafarers';
        case "ck":
            return '/cities-and-knights';
        case "colonistrush":
            return '/colonist-rush';
    }
}
export function getRulebookStylePathname(style) {
    if (style == "fullscreen") {
        return '';
    } else {
        return `/${style}`;
    }
}
